import React, { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import AccessoriesMainSpecificationLayout from "./AccessoriesMainSpecificationLayout";
import { BsArrowLeft } from "react-icons/bs";
import AccessoriesMainSpecificationParameter from "./AccessoriesMainSpecificationParameter";
import AccessoriesDependSpecificationLayout from "./AccessoriesDependSpecificationLayout";
import AccessoriesInnerSpecificationLayout from "./AccessoriesInnerSpecificationLayout";
import AccessoriesDependLimitLayout from "./AccessoriesDependLimitLayout";

const AccessoriesSpecificationLayout = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedParameterId, setSelectedParameterId] = useState(null);
  const [selectedDependSideLimitId, setSelectedDependSideLimitId] =
    useState(null);
  const [selectedMainSpecificationId, setSelectedMainSpecificationId] =
    useState(null);
  const [selectedDependSpecificationId, setSelectedDependSpecificationId] =
    useState(null);

  return (
    <>
      <div className="px-4 pt-4 mb-2 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <button
            className="mr-3 duration-300 ease-in-out hover:text-blue-900 hover:-translate-x-3"
            onClick={() => navigate("/furniture")}
          >
            <BsArrowLeft className="w-6 h-6 mr-1 hover:cursor-pointer" />
          </button>
          <h3 className="text-2xl">{location.state?.item?.name}</h3>
        </div>
        <div className="grid grid-cols-6 mt-4 gap-x-5">
          <div className="col-span-6 md:col-span-3">
            <AccessoriesMainSpecificationLayout
              id={id}
              setSelectedMainSpecificationId={setSelectedMainSpecificationId}
              setSelectedParameterId={setSelectedParameterId}
              setSelectedDependSideLimitId={setSelectedDependSideLimitId}
              setSelectedDependSpecificationId={
                setSelectedDependSpecificationId
              }
            />
          </div>
          <div className="col-span-6 md:col-span-3">
            <AccessoriesDependSpecificationLayout
              accessoriesId={id}
              setSelectedDependSpecificationId={
                setSelectedDependSpecificationId
              }
              selectedMainSpecificationId={selectedMainSpecificationId}
              setSelectedParameterId={setSelectedParameterId}
              setSelectedDependSideLimitId={setSelectedDependSideLimitId}
            />
            <AccessoriesInnerSpecificationLayout
              selectedDependSpecificationId={selectedDependSpecificationId}
              setSelectedParameterId={setSelectedParameterId}
              setSelectedDependSideLimitId={setSelectedDependSideLimitId}
            />
          </div>

          <div className="col-span-6 md:col-span-3">
            <AccessoriesDependLimitLayout
              selectedDependSideLimitId={selectedDependSideLimitId}
            />
          </div>

          <div className="col-span-6 md:col-span-3">
            <AccessoriesMainSpecificationParameter
              mainSpecificationId={selectedParameterId}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessoriesSpecificationLayout;
